"use strict";
/**
 * Not added yet in Figma, so this implementation is based on https://shinetools.slack.com/archives/C043U87DR9D/p1676391252844919?thread_ts=1676386746.921699&cid=C043U87DR9D
 */
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = require("../colors");
const progressBarTokens = {
    'progressBar-backgroundColor': (0, colors_1.getColorValue)('grey.300'),
    'progressBar-color': (0, colors_1.getColorValue)('grey.800'),
};
exports.default = progressBarTokens;
